<template>
  <div class="columns is-multiline content">
    <b-field :label="$t('editionRemise.label')"
             class="column is-3">
      <remise-personnalisee
        v-model="remiseAAjouter.libelle"
        @setRemiseRegie="setRemiseRegie($event)"
        :hidePopUp="hidePopUp"
        :cgvs="cgvs"
        :lignes-remise="ligneCommandeTemp.lignesRemise"
        @is-select="checkCgvSelect">
      </remise-personnalisee>
    </b-field>
    <b-field :label="$t('editionRemise.discount')"
             class="column is-3">
      <b-field>
        <input-currency v-model="remiseAAjouter.remise"
                        size="default" :disabled="hasCgvs">
        </input-currency>
        <b-select v-model="remiseAAjouter.typeRemise" :disabled="hasCgvs">
          <option v-for="saisie in listeTypeValeurRemise"
                  :key="saisie.code"
                  :value="saisie.code">
            {{$t(saisie.libelle)}}
          </option>
        </b-select>
      </b-field>
    </b-field>
    <b-field :label="$t('editionRemise.type')"
             class="column is-3">
      <b-select v-model="remiseAAjouter.type" expanded :disabled="disableCumuleMode">
        <option v-for="typeRemise in listeTypeRemise.filter(el => el.show)"
                :key="typeRemise.code"
                :value="typeRemise.code">
          {{$t(typeRemise.libelle)}}
        </option>
      </b-select>
    </b-field>

    <b-field class="column control">
      <div class="mgt-28px width-100percent">
        <dropdownButton
          type="is-addOrEdit"
          :actions="actionSecondary"
          @click="ajouterRemise(remiseAAjouter, false)">
            {{ $t('editionRemise.add') }}
        </dropdownButton>
      </div>
    </b-field>

    <div class="column is-12" v-if="errorInsert">
      <error-msg-component :messages="messages"
                           :error="errorInsert"
                           :title="'editionRemise.problemAddOccurred'"
                           :withEmplyFields="true"
                           @close="errorInsert = $event"/>
    </div>
    <v-client-table :data="ligneCommandeTemp.lignesRemise"
                    class='column is-12'
                    :columns="columns"
                    :options="options"
                    ref='tableRemises'
                    v-if="ligneCommandeTemp">
      <div
        :class="{ 'has-text-weight-bold': estLigneSousTotal(props.row) }"
        slot="libelle" slot-scope="props">
        {{props.row.libelle}}
      </div>
      <div v-if="!estLigneSousTotal(props.row)" slot="type" slot-scope="props">
        {{$t(getTypeRemiseLibelle(props.row))}}
      </div>
      <div
        v-if="!estLigneSousTotal(props.row)"
        slot="remise"
        slot-scope="props"
        label="remise"
        class="has-text-right">
        {{ decimalsFormaterFct(props.row.remise) }}
        {{ $t(getTypeValeurRemiseLibelle(props.row)) }}
      </div>
      <div
        :class="{ 'has-text-weight-bold': estLigneSousTotal(props.row) }"
        slot="montant" slot-scope="props"
        class="has-text-right">
        {{props.row.montant | formatDevise}}
      </div>
      <div
        v-if="showDeleteLigne(props)"
        slot="supprimer"
        slot-scope="props"
        class="has-text-centered">
        <a @click="suppression(props.index - 1)">
          <b-icon
            icon="delete-forever"
            type="is-danger">
          </b-icon>
        </a>
      </div>
      <template slot="prependBody">
        <tr v-if="displayMontant" class="has-background-cancel">
          <td class="has-text-weight-bold">
            {{this.$i18n.t('editionRemise.total')}}
          </td>
          <td></td>
          <td></td>
          <td class="has-text-right has-text-weight-bold">
            {{ligneCommandeTemp.totalAvantRemise | formatDevise}}
          </td>
          <td></td>
        </tr>
      </template>
      <template slot="appendBody">
        <tr class="has-background-cancel">
          <td class="has-text-weight-bold"><span v-if="displayMontant">
            {{this.$i18n.t('editionRemise.totalRemise')}}
          </span></td>
          <td class="has-text-right">{{ligneCommandeTemp.remise}} %</td>
          <td></td>
          <td class="has-text-right has-text-weight-bold" v-if="displayMontant">
            {{ligneCommandeTemp.totalHt | formatDevise}}
          </td>
          <td></td>
        </tr>
      </template>
    </v-client-table>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import dropdownButton from '@/components/general/button/dropdownButton';
import remiseValidation from '@/services/devisCommandes/validation/addRemiseValidation';
import * as remiseF2B from '@/services/devisCommandes/traductionRemiseBackFront';
import calculLignesRemise from '@/services/devisCommandes/calcul/calculLignesRemise';
import genererLigneRemise from '@/services/devisCommandes/genererLigneRemise';
import inputCurrency from '@/components/general/inputCurrency';
import * as devisConf from '@/configuration/devisConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, TEXTS } from '@/configuration/clientTableConf';
import decimalsFormater from '@/services/general/decimalsFormater';
import remisePersonnalisee from '@/components/devisCommandes/remisePersonnalisee';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ligneCommandeTemp: {
      type: Object,
      required: true,
    },
    ligneRegroupement: {
      required: false,
      type: Object,
      default: null,
    },
    displayMontant: {
      type: Boolean,
      required: true,
    },
    disableCumuleMode: {
      type: Boolean,
      required: false,
    },
    cgvs: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      messages: [],
      errorInsert: false,
      remiseAAjouter: genererLigneRemise(),
      listeTypeRemise: devisConf.LISTE_TYPE_REMISE,
      decimalsFormaterFct: decimalsFormater,
      hidePopUp: false,
      currentOrdre: 0,
    };
  },
  components: {
    inputCurrency,
    dropdownButton,
    errorMsgComponent,
    remisePersonnalisee,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    actionSecondary() {
      const actions = [
        {
          label: this.$t('editionRemise.sousTotal'),
          action: () => { this.ajouterSousTotal(); },
        },
      ];
      return actions;
    },
    hasCgvs() {
      return this.cgvs.length > 0;
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    listeTypeValeurRemise() {
      return devisConf.LISTE_SAISIES.filter((type) => (
        type.code !== devisConf.TYPE_REMISE_FRONT_MAJORATION_MONTANT
        && type.code !== devisConf.TYPE_REMISE_FRONT_REMISE_MONTANT
      ));
    },
    findOrdre() {
      if (this.ligneCommandeTemp.lignesRemise.length === 0) return 0;
      const ordres = this.ligneCommandeTemp.lignesRemise.map((r) => { return r.ordre; });
      return Math.max(...ordres) + 1;
    },
    columns() {
      const columns = ['libelle', 'remise', 'type', 'supprimer'];
      if (this.displayMontant) {
        columns.splice(columns.findIndex(column => column === 'supprimer'), 0, 'montant');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      texts.noResults = this.$i18n.t('editionRemise.noResults');
      return {
        headings: {
          libelle: this.$i18n.t('editionRemise.label'),
          remise: this.$i18n.t('editionRemise.discount'),
          type: this.$i18n.t('editionRemise.type'),
          montant: this.$i18n.t('editionRemise.amount'),
          supprimer: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortable: [],
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    setRemiseRegie(remise) {
      this.remiseAAjouter.isRemiseRegie = remise;
      this.$emit('setRemiseRegie', remise.isRemiseRegie);
    },
    getTypeRemiseLibelle(ligneRemise) {
      if (!ligneRemise.type) return '';
      return this.listeTypeRemise.find((typeRemise) => {
        return typeRemise.code === ligneRemise.type;
      }).libelle;
    },
    getTypeValeurRemiseLibelle(ligneRemise) {
      if (!ligneRemise.typeRemise) return '';
      return devisConf.LISTE_TYPE_REMISE_BACK.find((typeSaisie) => {
        return typeSaisie.code === ligneRemise.typeRemise;
      }).libelle;
    },
    suppression(index) {
      if (this.ligneCommandeTemp.listeMontant) { // utile pour la soulte sur multi remise
        this.ligneCommandeTemp.listeMontant.splice(index, 1);
      }
      this.ligneCommandeTemp.lignesRemise.splice(index, 1);
      this.currentOrdre = this.findOrdre;
      calculLignesRemise(this.ligneCommandeTemp);
    },
    ajouterRemise(remiseAAjouter, modeAAtteindre) {
      this.messages = [];
      remiseAAjouter.montant = 0;
      remiseValidation(remiseAAjouter, this.messages, this.modulePresseActive);
      this.errorInsert = this.messages.length > 0;
      if (this.errorInsert) return;
      this.currentOrdre = this.findOrdre;
      remiseAAjouter.ordre = this.currentOrdre;
      remiseAAjouter.isModeAAtteindre = modeAAtteindre;
      const realRemise = cloneDeep(remiseAAjouter);
      remiseF2B.fromTypeRemiseFront(realRemise, remiseAAjouter.typeRemise);
      remiseF2B.fromMontantRemiseFront(realRemise, remiseAAjouter.typeRemise,
        remiseAAjouter.remise);
      this.ligneCommandeTemp.lignesRemise.push(realRemise);
      calculLignesRemise(this.ligneCommandeTemp);
      this.remiseAAjouter = genererLigneRemise();
      if (this.ligneCommandeTemp.listeMontant) { // utile pour la soulte sur multi remise
        this.ligneCommandeTemp.listeMontant.push(this.ligneCommandeTemp.totalHt);
      }
    },
    estLigneSousTotal(ligne) {
      return ligne.type === devisConf.TYPE_REMISE_SOUS_TOTAL;
    },
    showDeleteLigne(props) {
      const ligneSousTotal = this.ligneCommandeTemp.lignesRemise
        .filter((ligne) => this.estLigneSousTotal(ligne));
      if (ligneSousTotal.length) return props.index === this.ligneCommandeTemp.lignesRemise.length;
      return true;
    },
    ajouterSousTotal() {
      const ligne = genererLigneRemise();
      ligne.typeRemise = devisConf.POURCENTAGE;
      ligne.type = devisConf.TYPE_REMISE_SOUS_TOTAL;
      ligne.libelle = this.$t('general.discountTypeLigne.sousTotal');
      this.currentOrdre = this.findOrdre;
      ligne.ordre = this.currentOrdre;
      this.ligneCommandeTemp.lignesRemise.push(ligne);
      calculLignesRemise(this.ligneCommandeTemp);
    },
    checkCgvSelect(remise) {
      const cgv = this.cgvs.find(c => c.id === remise.cgvId);
      if (cgv) {
        this.remiseAAjouter = cloneDeep({
          ...this.remiseAAjouter,
          remise: Math.abs(cgv.remise),
          type: cgv.type,
          typeRemise: cgv.remise > 0
            ? devisConf.TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE
            : devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE,
        });
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
